import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import type { CatalogBuild } from "../../model/HeroBuilds";
import { AbilityOrder } from "../AbilityOrder";
import { BuildPurchases } from "./BuildPurchases";

const MATCHES = msg({
  id: "builds.details.matches",
  message:
    "{count, plural, one {# match with this build over 30 days} other {# matches with this build over 30 days}}",
});

type BuildDetailsProps = {
  build: CatalogBuild;
  id: string;
};

// Раскрытая сборка (доска `BuildDetails.dc.html`): закуп по фазам матча и прокачка
// умений у сильных игроков с этой сборкой, внизу — на скольких матчах это посчитано.
export const BuildDetails = ({ build, id }: BuildDetailsProps) => {
  const { _ } = useLingui();
  return (
    <div id={id} className="flex flex-col gap-[18px] border-t border-surface-raised pt-3.5">
      {build.purchases.length > 0 && <BuildPurchases purchases={build.purchases} />}
      {build.ability_order !== null && <AbilityOrder order={build.ability_order} />}
      <span className="text-xs text-subtle">
        {_({ ...MATCHES, values: { count: build.matches } })}
      </span>
    </div>
  );
};
